// Campus photo for /colleges/university-of-new-hampshire: CC BY-SA 3.0, by John Phelan, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AThe_slope_behind_Thompson_Hall%2C_UNH%2C_Durham_NH.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/university-of-new-hampshire/; credited under the photo.
const photo = {
    "slug": "university-of-new-hampshire",
    "alt": "Thompson Hall at the University of New Hampshire in Durham, New Hampshire",
    "src": "/colleges/university-of-new-hampshire/campus-1600.webp",
    "srcSmall": "/colleges/university-of-new-hampshire/campus-800.webp",
    "srcMid": "/colleges/university-of-new-hampshire/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/university-of-new-hampshire/og.jpg",
    "title": "The slope behind Thompson Hall, UNH, Durham NH",
    "author": "John Phelan",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AThe_slope_behind_Thompson_Hall%2C_UNH%2C_Durham_NH.jpg",
    "read": "2026-10-01"
};

export default photo;
